import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type ContainerProps = {
  children: ReactNode;
  narrow?: boolean;
  className?: string;
};

const Container = ({ children, narrow, className }: ContainerProps) => (
  <div className={cn(narrow ? "container-narrow" : "container-wide", className)}>
    {children}
  </div>
);

export default Container;
